import * as React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { PostQuery } from './Shared';

const ReckonRedirectData = () => {
    let navigate = useNavigate();
    const { code, state } = useParams();
    const [isError, setIsError] = React.useState(false);

    React.useEffect(() => {
        saveAuth();
    }, []);

    const saveAuth = async () => {
        //decode state parameter
        var actual = JSON.parse(window.atob(state ?? ""));

        //save the quick books code and realmid
        var authDetails = {
            code: code
        };

        if (code) {
            //save the reckon authentication details
            const baseURL = window.location.origin;
            const apiURL = new URL('api/SaveReckonAuthentication', baseURL);

            try {
                var jsonItem = JSON.stringify(authDetails);

                const apiUrl = "SaveReckonAuthentication";
                var result = await PostQuery(apiUrl, jsonItem);
                if (result.error) {
                    toast.error("Error saving data!");
                } else {
                    if (result.data.isError) {
                        var errorList = result.data.messages as any[];
                        errorList.map(function (error: any) {
                            toast.error(error.content);
                        });
                        setIsError(true);
                    } else {
                        //redirect to the appropriate page with the code and realmid paramerters
                        var redirect = "/" + actual.page;
                        if (actual.id) {
                            redirect += "/" + actual.id;
                        }
                        navigate(redirect);
                    }
                }
            } catch (e) {
                toast.error("Error redirecting from Reckon Login!");
            }
        }
    }

    return (
        <div>
            <div className={isError ? "hidden" : "" }>Redirecting...</div>
            <div className={isError ? "makeitred" : "hidden"}>
            Error logging in from Reckon!
            </div>
             
        </div>
    );
}

export default ReckonRedirectData;